import { ArrowLeftRight } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { openedOrganisation, returnToPlatform } from '../auth/organisation-switch'

/**
 * Shown on every screen while a super administrator is inside another organisation,
 * so nobody forgets whose data they are changing — and the way back is one click.
 */
export function OrganisationBanner() {
  const { t } = useTranslation()
  const [leaving, setLeaving] = useState(false)
  const name = openedOrganisation()
  if (name === null) return null

  return (
    <div
      role="status"
      data-testid="organisation-banner"
      className="flex flex-wrap items-center justify-between gap-2 bg-accent px-4 py-1.5 text-sm text-accent-fg"
    >
      <span className="flex min-w-0 items-center gap-2">
        <ArrowLeftRight aria-hidden className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('common:platformBanner.managing', { name })}</span>
      </span>
      <button
        type="button"
        disabled={leaving}
        onClick={() => {
          setLeaving(true)
          void returnToPlatform()
        }}
        className="rounded border border-current px-2 py-0.5 text-xs font-medium hover:bg-white/10"
      >
        {t('common:platformBanner.back')}
      </button>
    </div>
  )
}
